import React, {useState, useEffect, useContext} from 'react';
import { Link, useNavigate, } from 'react-router-dom';
import './register.css';
import RightLoginRegister from '../../components/rightLoginRegister/RightLoginRegister';
import FormInput from '../../components/formInput/FormInput';
import DropDownComponent from '../../components/dropDownComponent/DropDownComponent';
import { communes, wilayas } from '../../data';
import { AuthContext } from '../../context/authContext/AuthContext';
import { register } from '../../context/authContext/apiCalls';

function Register() {
    const [errorBox, setErrorBox] = useState("");
    const [nom, setNom] = useState("");
    const [email, setEmail] = useState("");
    const [tel1, setTel1] = useState("");
    const [tel2, setTel2] = useState("");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const { dispatch, isFetching, error, mess } = useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (mess !== "") {
            setErrorBox("");          
            navigate("/login");
        }
    }, [mess])

    useEffect(() => {
        if (error != false) {
            setErrorBox(error);
        }
    }, [error])

    const registerHandler = (e)=>{
        e.preventDefault();
        if (nom.trim() == "") {
            setErrorBox('Vous devez compléter le Nom');
            return;
        }
        if (tel1.trim() == "") {
            setErrorBox('Vous devez compléter Tel 1');
            return;
        }
        if (username.trim() == "") {
            setErrorBox('Vous devez compléter le Username');
            return;
        }
        if (password.trim() == "") {
            setErrorBox('Vous devez compléter le Password');
            return;
        }
        if (confirmPassword.trim() == "") {
            setErrorBox('Vous devez confirmer le Password');
            return;
        }
        if(confirmPassword !== password){
            setErrorBox('Password et Confirmer Password sont different');
            return;
        }
        register(dispatch, {username, password, nom, email, tel1, tel2});
    }

    return (
        <div className="container">
            <div className="box">
                <div className="logo">
                    <img src="/logo.png" alt="" />
                </div>
                <form action="">
                    <h1>Créer un Compte</h1>

                    {errorBox !== "" && (<div className='box-error'>{errorBox}</div>)}

                    <div className='side-to-side'>
                        <FormInput label={'Nom *'} itemInput={nom} setItemInput={setNom} auth />
                    </div>
                    <FormInput label='Email ' itemInput={email} setItemInput={setEmail} auth />
                    <div className='side-to-side'>
                        <FormInput label='Tel 1 *' itemInput={tel1} setItemInput={setTel1} auth />
                        <FormInput label='Tel 2' itemInput={tel2} setItemInput={setTel2} auth />
                    </div>
                    <FormInput label='Username *' itemInput={username} setItemInput={setUsername} auth />
                    <FormInput label='Password *' itemInput={password} setItemInput={setPassword} auth isPassword/>
                    <FormInput label='ConfirmPassword *' itemInput={confirmPassword} setItemInput={setConfirmPassword} auth isPassword/>

                    <button onClick={registerHandler} style={isFetching ? {cursor:'not-allowed',pointerEvents: 'none'} : {}}>
                      <span>{ isFetching ? "S'inscrire ..." : "S'inscrire"}</span>
                    </button>
                    <p>
                        Vous avez déja un compte ? <Link to={"/login"}>Se Connecter</Link>
                    </p>
                </form>
            </div>

            <RightLoginRegister />
        </div>
    )
}

export default Register
